import z from 'zod';
import { uuid } from './zod';
const ref = (id) => z.object({
    _id: uuid,
    _ref: z.literal(id),
});
export const alarmRef = ref('Alarm');
export const alarmEventRef = ref('AlarmEvent');
export const alarmHelperRef = ref('AlarmHelper');
export const alarmPushSubscriptionRef = ref('AlarmPushSubscription');
export const alarmProfessionalResponderRef = ref('AlarmProfessionalResponder');
export const assetRef = ref('Asset');
export const assetGroupRef = ref('AssetGroup');
export const beaconRef = ref('Beacon');
export const contactListRef = ref('ContactList');
export const customerRef = ref('Customer');
export const customerAlarmCenterRelationRef = ref('CustomerAlarmCenterRelation');
export const customerUserRelationRef = ref('CustomerUserRelation');
export const deviceRef = ref('Device');
export const observationRef = ref('Observation');
export const observationTriggerRef = ref('ObservationTrigger');
export const overlayRef = ref('Overlay');
export const reportTriggerRef = ref('ReportTrigger');
export const reportTriggerRunRef = ref('ReportTriggerRun');
export const roleRef = ref('Role');
export const staticResponderRef = ref('StaticResponder');
export const userRef = ref('User');
export const webhookRef = ref('Webhook');
export const zoneRef = ref('Zone');
